var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-card',{staticClass:"lg:w-10/12 md:w-10/12 select-product"},[_c('p',{staticClass:"mb-8 text-center"},[_vm._v("What type of product would you like to create?")]),_c('div',{staticClass:"md:w-8/12 lg:w-10/12 button-container"},[_c('a',{staticClass:"bn-button",on:{"click":function($event){return _vm.$router.push({
        name: 'pay-later-product'
    })}}},[_vm._v(" B2C BNPL ")]),_c('a',{staticClass:"bn-button",on:{"click":function($event){return _vm.$router.push({
        name: 'pay-later-product'
    })}}},[_vm._v(" B2C BNPO ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }